import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { FC, useEffect } from 'react';
import { IModalComponentProps } from '@context/modal_context';
import Input from '@components/common/input';
import { isValidUrl } from '@utils/validation';

const ApiKeyWebhooksCreateUpdateModal: FC<
    IModalComponentProps<{ isUpdate?: boolean; order_webhook?: string; refund_webhook?: string }>
> = ({ modalData, handleChangeDisable, changeModalData }) => {
    useEffect(() => {
        if (modalData?.order_webhook) {
            handleChangeDisable(!isValidUrl(modalData.order_webhook));
        }
        if (modalData?.refund_webhook) {
            handleChangeDisable(!isValidUrl(modalData.refund_webhook));
        }
        if (!modalData?.order_webhook && !modalData?.refund_webhook) {
            handleChangeDisable(true);
        }
    }, [modalData]);

    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4">
                {modalData?.isUpdate ? 'Update webhooks' : 'Add webhooks'}
            </Typography>
            <div className={styles.content}>
                <div className={styles.item}>
                    <Input
                        value={modalData?.order_webhook}
                        onChange={(val) => changeModalData({ ...modalData, order_webhook: val })}
                        label="Order webhook"
                        full
                        placeholder="https://example.com/order-webhook"
                    />
                </div>
                <div className={styles.item}>
                    <Input
                        value={modalData?.refund_webhook}
                        onChange={(val) => changeModalData({ ...modalData, refund_webhook: val })}
                        label="Refund webhook"
                        full
                        placeholder="https://example.com/order-webhook"
                    />
                </div>
            </div>
        </div>
    );
};

export default ApiKeyWebhooksCreateUpdateModal;
